(() => {
  if (customElements.get('tc-sale-campaign')) return;
  customElements.define('tc-sale-campaign', class extends HTMLElement {
    connectedCallback() {
      this.deadline = Date.parse(this.dataset.end);
      this.clock = this.querySelector('[role="timer"]');
      this.date = this.querySelector('time');
      this.units = ['days', 'hours', 'minutes', 'seconds'].map(unit => this.querySelector(`[data-unit="${unit}"]`));
      if (!Number.isFinite(this.deadline)) { this.expire(); return; }
      this.tick();
      if (!this.hidden) this.interval = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() { clearInterval(this.interval); }
    tick() {
      const remaining = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
      if (remaining === 0) { this.expire(); return; }
      const values = [Math.floor(remaining / 86400), Math.floor(remaining / 3600) % 24, Math.floor(remaining / 60) % 60, remaining % 60];
      this.units.forEach((unit, index) => { unit.textContent = String(values[index]).padStart(2, '0'); });
      this.clock.hidden = false;
      this.date.hidden = true;
    }
    expire() {
      clearInterval(this.interval);
      this.hidden = true;
      const section = this.closest('.tc-home');
      const evergreen = section.querySelector('.tc-home-evergreen');
      if (evergreen) evergreen.hidden = false;
      const heading = section.querySelector('h1');
      if (heading) heading.textContent = this.dataset.heading;
    }
  });
})();
